import axios from 'axios';
import apiConfig from '../../api.config';

export default function getHbxSuscriptionStatus({ hotelId, nameProduct }) {
  const {
    host,
    URIs: { guestHbxProductSuscriptionStatus },
  } = apiConfig;

  const data = {
    hotelId,
    nameProduct,
  };

  const uri = `${host}${guestHbxProductSuscriptionStatus}`
    .replace(':hotelId', hotelId)
    .replace(':nameProduct', nameProduct);

  return axios
    .get(uri, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data?.suscription || false;
    })
    .catch(err => {
      console.error(err);
      return false;
    });
}
